'use strict';

exports.__esModule = true;

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

var _actionTypes = require('../constants/actionTypes');

var _container = require('../container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var methodConfigs = _container2.default.getDefinition('requestMethods').getArguments();

      next(action);

      (0, _each2.default)(methodConfigs, function (config, method) {
        if (action.type === _actionTypes.FETCH.for(method).REQUEST && config.middleware) {
          // if (!config.middleware) {
          //     throw `Warning: Request for method ${method} has no matching middleware.`;
          // }
          config.middleware(store, next, action, config);
        }
      });
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/middleware/index.js
// module id = 698
// module chunks = 0